import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { BannerItem, HotRecommendItem, newAlbumItem, TopListInfo, ArtistsItem } from '@/types/recommend-api'

interface RecommendState {
    topBanners: BannerItem[]
    hotRecommends: HotRecommendItem[]
    newAlbums: newAlbumItem[]
    topUpList: TopListInfo
    topNewList: TopListInfo
    topOriginList: TopListInfo
    settleSingers: ArtistsItem[]
}

const initialState: RecommendState = {
    topBanners: [],
    hotRecommends: [],
    newAlbums: [],
    topUpList: {} as TopListInfo,
    topNewList: {} as TopListInfo,
    topOriginList: {} as TopListInfo,
    settleSingers: [],
}

const recommendSlice = createSlice({
    name: 'recommend',
    initialState,
    reducers: {
        changeTopBanner(state, action: PayloadAction<BannerItem[]>) {
            state.topBanners = action.payload
        },
        changeHotRecommend(state, action: PayloadAction<HotRecommendItem[]>) {
            state.hotRecommends = action.payload
        },
        changeNewAlbum(state, action: PayloadAction<newAlbumItem[]>) {
            state.newAlbums = action.payload
        },
        changeTopUpList(state, action: PayloadAction<TopListInfo>) {
            state.topUpList = action.payload
        },
        changeTopNewList(state, action: PayloadAction<TopListInfo>) {
            state.topNewList = action.payload
        },
        changeTopOriginList(state, action: PayloadAction<TopListInfo>) {
            state.topOriginList = action.payload
        },
        changeSettleSingers(state, action: PayloadAction<ArtistsItem[]>) {
            state.settleSingers = action.payload
        },
    },
})

export const {
    changeTopBanner,
    changeHotRecommend,
    changeNewAlbum,
    changeTopUpList,
    changeTopNewList,
    changeTopOriginList,
    changeSettleSingers,
} = recommendSlice.actions

export default recommendSlice.reducer
